﻿/*!
    *
    * Wijmo Library 5.20251.34
    * https://developer.mescius.com/wijmo
    *
    * Copyright(c) MESCIUS inc. All rights reserved.
    *
    * Licensed under the End-User License Agreement For MESCIUS Wijmo Software.
    * us.sales@mescius.com
    * https://developer.mescius.com/wijmo/licensing
    *
    */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { VueApi, WjComponentBehavior } from '@mescius/wijmo.vue2.base';
import * as wjcGridSearch from '@mescius/wijmo.grid.search';
var WjFlexGridSearchBehavior = /** @class */ (function (_super) {
    __extends(WjFlexGridSearchBehavior, _super);
    function WjFlexGridSearchBehavior() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WjFlexGridSearchBehavior.tag = 'wj-flex-grid-search';
    WjFlexGridSearchBehavior.props = [
        'isDisabled',
        'tabOrder',
        'text',
        'delay',
        'searchAllColumns',
        'placeholder',
        'cssMatch',
        'grid'
    ];
    WjFlexGridSearchBehavior.events = [
        'initialized',
        'gotFocus',
        'lostFocus',
        'refreshing',
        'refreshed',
        'invalidInput'
    ];
    WjFlexGridSearchBehavior.classCtor = function () { return wjcGridSearch.FlexGridSearch; };
    return WjFlexGridSearchBehavior;
}(WjComponentBehavior));
/**
 * Vue component for the {@link wijmo.grid.search.FlexGridSearch} control.
 *
 * The component supports all properties and events of the pure JavaScript {@link wijmo.grid.search.FlexGridSearch} control it represents.
 *
 * The component includes an <b>initialized</b> event that is raised when the control is initialized after it is added to the page.
 * You can use this event to perform further initialization in addition to setting properties in markup.
 * The signature of the handler function is the same as any other Wijmo event handlers.
 */
export var WjFlexGridSearch = WjFlexGridSearchBehavior.register();
function registerV3WjFlexGridSearch(app) {
    app.component(WjFlexGridSearchBehavior.tag, WjFlexGridSearch);
}
export function registerGridSearch(app) {
    if (VueApi.isV3Plus) {
        registerV3WjFlexGridSearch(app);
    }
}
